import { ca } from '@cian/analytics';

export function trackOpenNewbuildingDescription() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'open_info_about_JK',
    useLastProducts: true,
  });
}
